import type { VisibleModelEdgeHoverOptions, VisibleModelEdgeReferencePointKind } from '../../types/sketch/VisibleModelEdgeProjection';

/**
 * 统一模型参考点的类型门禁，保证移入显示与轴向索引遵循同一设置。
 * @param kind 模型参考点类型。
 * @param options 当前模型参考点设置。
 * @returns 当前类型是否允许参与捕捉。
 */
export function isModelReferencePointSnapEnabled(kind: VisibleModelEdgeReferencePointKind, options: VisibleModelEdgeHoverOptions): boolean {
    // 模型总开关由调用入口判断；这里仅解释四类参考点的独立开关。
    switch (kind) {
        case 'endpoint': return options.endpointEnabled;
        case 'midpoint': return options.midpointEnabled;
        case 'center': return options.centerEnabled;
        case 'quadrant': return options.quadrantEnabled;
    }
}
